export enum LoginActionTypes {
    LOGIN_REQUEST_SEND = 'login_request_send',
    LOGIN_ERROR = 'login_error',
    LOGIN_SUCCESS = 'login_success',
}